<div class="document-preview">
  <div class="document-name">
    <img
      src="../../../../assets/images/file-earmark-medical.svg"
      alt="file-earmark-medical"
    />
    <ng-container *ngIf="isFileEdit; else fileName">
      <div>
        <div class="file-name-input-container">
          <input
            class="file-name-input"
            type="text"
            [(ngModel)]="tempFileName"
            appFileNameValidator
            #fileNameInput="ngModel"
            name="fileName"
            required
            [disabled]="isChangeNameLoading"
          />
          <ng-container *ngIf="isChangeNameLoading; else icons">
            <i class="fa-spin fas fa-spinner ms-2"></i>
          </ng-container>
          <ng-template #icons>
            <i
              class="pi pi-times pointer"
              style="color: red"
              [ngbTooltip]="'Discard'"
              (click)="discardClicked()"
            ></i>
            <i
              class="pi pi-check pointer"
              style="color: green"
              [ngbTooltip]="'Save'"
              [class.disabled]="fileNameInput.errors?.['invalidFileName']"
              (click)="saveClicked()"
            ></i>
          </ng-template>
        </div>
        <p class="form-error" *ngIf="fileNameInput.errors?.['invalidFileName']">
          Invalid file name. It cannot contain characters like / \ ? % * : | " <
          >
        </p>
      </div>
    </ng-container>
    <ng-template #fileName>
      <span
        class="file-name"
        [ngbTooltip]="'Click to edit'"
        (click)="onFileNameClick(doc?.name)"
        >{{ doc?.name ? doc?.name : doc?.properties?.doc_type }}</span
      >
    </ng-template>
  </div>
  <div class="document-info">
    <span class="size">{{ doc?.size | fileSize }}</span>

    <span class="upload-date">
      {{ doc?.created_at | formattedDateTime }}
    </span>
    <a [href]="doc?.url" target="_blank">
      <img src="../../../../assets/images/eye.svg" alt="" />
    </a>
    <div
      *ngIf="allowDelete"
      (click)="openDeleteConfMsg(doc?.id)"
      class="delete-file d-inline"
      style="margin-left: 5px; cursor: pointer"
    >
      <img src="../../../../assets/images/trash2-fill.svg" alt="" />
    </div>
  </div>
</div>

<!-- Delete file message -->
<app-confirmation-msg
  #deleteMessageComponent
  [isLoading]="loadingSubmit"
  (accepted)="deleteFile()"
  (rejected)="deleteMessageComponent.close()"
  [headerMessage]="'Confirmation Message'"
  [bodyMessage]="'Do you want to delete this file?'"
>
</app-confirmation-msg>
